import React, { Component } from "react";
import InputForm from "./InputForm";
import axios from "axios";
import { Button, Col, Tooltip, message } from 'antd';


class ProdutoFrame extends Component {
    state = {
        lista: [],
        codigo: {
            key: '0',
            label: '',
        },
        buscando: false,
        abrirLista: false,
        carregandoTodos: false,
    }

    componentDidUpdate(propsAnterior, stateAnterior) {
        if (this.state.codigo.key !== this.props.value.key) {
            this.setState({
                codigo: {
                    key: this.props.value.key,
                    label: '',
                },
                // lista: [{
                //     key: '0',
                //     label: ((this.props.descricaoPrimeiroItem) && (this.props.descricaoPrimeiroItem !== '')) ? this.props.descricaoPrimeiroItem : 'Todos os Produtos',
                // }, {
                //     key: this.props.value.key,
                //     label: this.props.value.label,
                // }]
            })
        }
    }

    componentDidMount() {
        // this.getListaRegistros();
    }

    abrirDropdownProdutos = () => {
        // O `open` enviado ao InputForm é a forma principal.
        // Este fallback garante a abertura também nas versões antigas do InputForm/AntD.
        setTimeout(() => {
            if (!this.produtoFrameContainer) return;

            const select = this.produtoFrameContainer.querySelector('.ant-select');
            const input = this.produtoFrameContainer.querySelector('.ant-select-search__field');
            const selection = this.produtoFrameContainer.querySelector('.ant-select-selection');

            if (input && input.focus) {
                input.focus();
            }

            // Se o InputForm repassou a prop `open`, o dropdown já está aberto.
            // Só simulamos o mouse quando a versão do InputForm não suporta essa prop.
            if (select && select.classList.contains('ant-select-open')) {
                return;
            }

            if (selection) {
                selection.dispatchEvent(new MouseEvent('mousedown', {
                    view: window,
                    bubbles: true,
                    cancelable: true,
                }));
            }
        }, 80);
    };

    fecharMensagemCarregando = () => {
        if (this.hideMensagemCarregando) {
            this.hideMensagemCarregando();
            this.hideMensagemCarregando = null;
        }
    };

    onCarregarTodos = () => {
        this.fecharMensagemCarregando();
        this.hideMensagemCarregando = message.loading('Carregando...', 0);
        this.getListaRegistros('', true);
    };

    getListaRegistros = (value, abrirAposCarregar = false) => {
        // Enquanto digita, mantém o dropdown e o foco abertos.
        // Não esvazia as opções antes de receber o próximo resultado.
        const buscaAtual = (this.sequenciaBusca || 0) + 1;
        this.sequenciaBusca = buscaAtual;
        this.setState({
            abrirLista: true,
            buscando: true,
            carregandoTodos: abrirAposCarregar,
        });

        clearTimeout(this.buscaRegistrosId);
        this.buscaRegistrosId = setTimeout(() => {
            // if (value.length >= 3) {
            axios.get('/produtos/lista', {
                params: {
                    nome: value,
                    situacao: 'A',
                    ehCodigo: ((value) && (parseInt(value)) && (value.length <= 6)) ? 1 : 0,
                    controlaEstoque: this.props.controlaEstoque ? this.props.controlaEstoque : '',
                }
            }).then(response => {
                // Descarta respostas de consultas antigas que chegaram atrasadas.
                if (buscaAtual !== this.sequenciaBusca) return;
                const { data } = response;
                const temProdutos = Array.isArray(data) && data.length > 0;

                // console.log('ProdutoFrame.getListaRegistros: ', data)

                const lista = data.map(regList => {
                    return {
                        key: String(regList.prod_idf) + '_' + String(regList.pest_tamanho) + '_' + String(regList.pest_cor),
                        label: (regList.prod_grade ? (regList.prod_descricao + ' - ' + regList.ptam_descricao + ' - ' + regList.pcor_descricao) : regList.prod_descricao) + ' [' + regList.prod_codigo + ']' + (regList.prod_cod_barras !== '' ? ' [' + regList.prod_cod_barras + ']' : ''),
                        idf: regList.prod_idf,
                        cod: regList.prod_codigo,
                        descr: regList.prod_descricao,
                        prod_ncm: regList.prod_ncm,
                        pest_qtde: regList.pest_qtde,
                        vlrVenda: regList.prod_vlr_venda,
                        prod_vlr_custo: regList.prod_vlr_custo,
                        prod_grade: regList.prod_grade,
                        prod_cod_barras: regList.prod_cod_barras,
                        pest_item: regList.prod_idf,
                        pest_tamanho: regList.pest_tamanho,
                        pest_cor: regList.pest_cor,
                        ptam_descricao: regList.ptam_descricao,
                        pcor_descricao: regList.pcor_descricao,
                        prod_tipo_produto: regList.prod_tipo_produto,
                        prod_ncm: regList.prod_ncm,
                        med_descricao: regList.med_descricao,
                        prod_imagem: regList.prod_imagem || '',
                        prod_empresa: regList.prod_empresa || '',
                    }
                });

                // if ((value) && (parseInt(value)) && (value.length <= 6) && (lista.length = 1)) {
                //     const state = {};
                //     state[this.props.id] = {
                //         key: lista[0].key,
                //         label: lista[0].label,
                //         idf: lista[0].idf,
                //         cod: lista[0].cod,
                //         descr: lista[0].descr,
                //         pest_qtde: lista[0].pest_qtde,
                //         prod_grade: lista[0].prod_grade,
                //         prod_cod_barras: lista[0].prod_cod_barras,
                //         pest_item: lista[0].pest_item,
                //         pest_tamanho: lista[0].pest_tamanho,
                //         pest_cor: lista[0].pest_cor,
                //         ptam_descricao: lista[0].ptam_descricao,
                //         pcor_descricao: lista[0].pcor_descricao,
                //         prod_vlr_custo: lista[0].prod_vlr_custo,
                //         vlrVenda: lista[0].vlrVenda,
                //     };
                //     this.props.onChange(state);
                // } else {
                    if ((this.props.descricaoPrimeiroItem) && (this.props.descricaoPrimeiroItem !== '')) {
                        lista.unshift({ key: '0', label: this.props.descricaoPrimeiroItem });
                    }
                // }


                this.setState({
                    lista,
                    buscando: false,
                    carregandoTodos: false,
                    abrirLista: true,
                }, () => {
                    if (abrirAposCarregar) {
                        this.fecharMensagemCarregando();
                    }

                    if (abrirAposCarregar && temProdutos) {
                        this.abrirDropdownProdutos();
                    }
                })
            }).catch(error => {
                if (buscaAtual !== this.sequenciaBusca) return;
                console.error(error.response);
                this.fecharMensagemCarregando();
                this.setState({
                    lista: [],
                    buscando: false,
                    carregandoTodos: false,
                    abrirLista: true,
                })
            })
            // }
        }, 350);
    };

    onChange = event => {
        clearTimeout(this.buscaRegistrosId);
        this.sequenciaBusca = (this.sequenciaBusca || 0) + 1;
        const value = event.target.value;
        const id = event.target.id;
        const state = {};
        const iInd = this.state.lista.findIndex(registro => String(registro.key) === String(value.key));
        if (iInd < 0) return;
        state[id] = {
            key: value.key,
            label: value.label,
            idf: this.state.lista[iInd].idf,
            cod: this.state.lista[iInd].cod,
            descr: this.state.lista[iInd].descr,
            pest_qtde: this.state.lista[iInd].pest_qtde,
            prod_grade: this.state.lista[iInd].prod_grade,
            prod_cod_barras: this.state.lista[iInd].prod_cod_barras,
            pest_item: this.state.lista[iInd].pest_item,
            pest_tamanho: this.state.lista[iInd].pest_tamanho,
            pest_cor: this.state.lista[iInd].pest_cor,
            ptam_descricao: this.state.lista[iInd].ptam_descricao,
            pcor_descricao: this.state.lista[iInd].pcor_descricao,
            prod_vlr_custo: this.state.lista[iInd].prod_vlr_custo,
            vlrVenda: this.state.lista[iInd].vlrVenda,
            prod_tipo_produto: this.state.lista[iInd].prod_tipo_produto,
            prod_ncm: this.state.lista[iInd].prod_ncm,
            med_descricao: this.state.lista[iInd].med_descricao,
            prod_imagem: this.state.lista[iInd].prod_imagem || '',
            prod_empresa: this.state.lista[iInd].prod_empresa || '',
        };
        // Ao selecionar um produto, fecha imediatamente o dropdown.
        this.setState({ abrirLista: false }, () => {
            if (this.produtoFrameContainer) {
                const input = this.produtoFrameContainer.querySelector('.ant-select-search__field');
                if (input && input.blur) {
                    input.blur();
                }

                const selection = this.produtoFrameContainer.querySelector('.ant-select-selection');
                if (selection && selection.blur) {
                    selection.blur();
                }
            }
        });

        this.props.onChange(state);
    };

    componentWillUnmount() {
        this.sequenciaBusca = (this.sequenciaBusca || 0) + 1;
        clearTimeout(this.buscaRegistrosId);
        this.fecharMensagemCarregando();
    }

    onDropdownVisibleChange = (visivel) => {
        this.setState({ abrirLista: Boolean(visivel) });
    };


    render() {
        const { label, id, width, disabled } = this.props;
        const { lista, codigo, buscando, abrirLista, carregandoTodos } = this.state;

        // console.log('ProdutoFrame - this.props: ', this.props);
        // console.log('ProdutoFrame - this.state: ', this.state);

        return (
            <span style={{}} ref={ref => { this.produtoFrameContainer = ref; }}>
                <span>{label}</span>
                <InputForm
                    type="select"
                    id={id}
                    ref={id}
                    value={codigo}
                    onChange={this.onChange}
                    data={lista}
                    validator={value => Boolean(value)}
                    onSearch={this.getListaRegistros}
                    fetching={buscando}
                    open={abrirLista}
                    dropdownVisible={abrirLista}
                    onDropdownVisibleChange={this.onDropdownVisibleChange}
                    showArrow={false}
                    filterOption={false}
                    notFoundContent={buscando ? 'Carregando...' : null}
                    defaultActiveFirstOption={false}
                    showSearch
                    placeholder="Digite o Produto"
                    style={{ width: width }}
                    disabled={disabled ? true : false}
                />
                <div style={{ float: "right", margin: 0, padding: 0, marginTop: -63 }}>
                    <Tooltip title={carregandoTodos ? "Carregando..." : "Carregar Todos"}>
                        <Button
                            type="ghost"
                            icon="reload"
                            onClick={this.onCarregarTodos}
                            loading={carregandoTodos}
                            style={{ color: 'rgba(0,0,0,0.4)', fontSize: 20, marginTop: 4, marginLeft: -39, borderWidth: 0 }}
                        />
                    </Tooltip>
                </div>
            </span>
        );
    }
}

export default ProdutoFrame;



// WEBPACK FOOTER //
// ./src/components/ProdutoFrame.js